import { Chip } from '@mui/material'
import { ExpandMore, SchoolOutlined, WorkOutline } from '@mui/icons-material'
import { CreditProfileKind } from '../products/credit-profile'

const profileIcons = {
  student: SchoolOutlined,
  doctor: WorkOutline,
  professional: WorkOutline,
}

type ProfileChipProps = {
  profile: CreditProfileKind
  label: string
  onClick: () => void
}

export function ProfileChip({ profile, label, onClick }: ProfileChipProps) {
  const Icon = profileIcons[profile]

  return (
    <Chip
      icon={<Icon />}
      label={label}
      deleteIcon={<ExpandMore />}
      onDelete={onClick}
      onClick={onClick}
      size="small"
      aria-label="Ver perfil"
      sx={{
        bgcolor: 'primary.100',
        color: 'primary.main',
        fontWeight: 500,
        '& .MuiChip-deleteIcon': { color: 'primary.main' },
      }}
    />
  )
}
